export enum UserInvitationType {
  Default = 'Default',
  PubCenterSelfServeUser = 'PubCenterSelfServeUser'
}
